'use client';

import { Button, Image, Modal, Title, TitleLevels, TypographyColor, View } from '@bytel/trilogy-react-ts';

import { RangesNewGeneration } from '@app-types/fai';

const modals: Record<
    RangesNewGeneration,
    {
        title: string;
        img: string;
        subtitle: string;
        content: string;
    }
> = {
    [RangesNewGeneration.VERY_FIT]: {
        title: 'B&YOU Pure Fibre ',
        img: `https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/happy-woman.webp`,
        subtitle: 'Enfin un super flux, sans superflu',
        content: `<p><strong>✓ La fibre, rien que la fibre</strong><br />
Pas besoin de TV ni de téléphone fixe ? Avec B&YOU Pure fibre, on vous propose une nouvelle expérience à la maison centrée sur votre besoin principal : une super connexion. Sans superflu.</p>
<p><strong>✓ Très haut débit, perf’ garantie</strong><br />
B&YOU Pure fibre, c’est le luxe d’une connexion ultra-rapide à la maison. Avec jusqu’à 8 Gb/s en téléchargement et 1 Gb/s en envoi*, on a mis la barre haute pour satisfaire tous vos besoins.</p>
<p><strong>✓ Un petit prix pour du super quali</strong><br />
Avec B&YOU Pure fibre, vous ne payez que pour ce dont vous avez vraiment besoin : une connexion optimale à la maison. Et en plus, c’est sans surprise : il ne change pas au bout d’un an.</p>
<p><strong>✓ Une assistance 7j/7 depuis votre appli</strong><br />
Un problème ? Pas de problème ! Ouvrez votre application Bouygues Telecom, et accédez à une assistance disponible 24h/24 et par téléphone les 2 premiers mois.</p>
<small>*Débit maximal disponible sous réserve d’éligibilité.</small>`,
    },
    [RangesNewGeneration.MUST]: {
        title: 'Série spéciale Bbox',
        img: `https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/happy-couple.webp`,
        subtitle: 'La fibre avec TV et appels illimités pour les clients mobile et B&you',
        content: `<p><strong>✓ 180 chaînes TV disponibles</strong><br />
Grâce au puissant décodeur TV Bbox 4K, profitez des <a href="https://bytl.fr/Guide-TV" target="_blank" class="link has-text-tertiary">180 chaînes TV incluses</a> avec votre offre.</p>
<p><strong>✓ Appels illimités vers les fixes</strong><br />
Avec la ligne téléphonique incluse, passez des appels illimités vers les fixes en France et plus de 110 pays.</p>
<p><strong>✓ Installation clé en main</strong><br />
Notre équipe viendra chez vous gratuitement pour activer la fibre, votre Bbox et votre décodeur TV.</p>
<p><strong>✓ Internet garanti dès le 1er jour</strong><br />
Adieu les coupures. Une clé 4G avec 200 Go d’internet est à votre disposition dès la souscription de votre box internet.</p>
<p><strong>✓ Une assistance 7j/7 depuis votre appli</strong><br />
Un problème ? Pas de problème ! Ouvrez votre application Bouygues Telecom, et accédez à une assistance disponible 24h/24 et par téléphone les 2 premiers mois.</p>`,
    },
};
const ModalOtis = ({
    range_ng,
    onClose,
    active,
}: {
    range_ng?: RangesNewGeneration;
    onClose: () => void;
    active: boolean;
}) => {
    const modalContent = modals[range_ng || RangesNewGeneration.MUST];
    return (
        <Modal closeIcon active={active} onClose={onClose} className='otis-modal'>
            <View className='otis-modal-content'>
                <Title level={TitleLevels.TWO} className=''>
                    {modalContent.title}
                </Title>
                <View>
                    <Title level={TitleLevels.THREE} typo={TypographyColor.TEXT_TERTIARY}>
                        {modalContent.subtitle}
                    </Title>
                    <View className='mb-4 mt-4 img-cover'>
                        <Image src={modalContent.img} alt={modalContent.title} />
                    </View>
                    <div dangerouslySetInnerHTML={{ __html: modalContent.content }}></div>
                </View>
            </View>

            <View className='mt-4'>
                <Button className='is-primary oisBg is-fullwidth has-byou-background' onClick={onClose}>
                    Fermer
                </Button>
            </View>
        </Modal>
    );
};

export default ModalOtis;
